import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import OrganizationAppResource from './OrganizationAppResource';

class OrganizationBrandingAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'organization-branding';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'organizations/brandings';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'organizationUuid',
      'organization',
      'displayName',
      'platformName',
      'brandingPath',
      'logoUuid',
      'logo',
      'faviconUuid',
      'favicon',
      'primaryColor',
      'primaryColorLighten',
      'primaryColorDarken',
      'accentColor',
      'copyrightText',
      'compiled',
      'affiliateNewMembers',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      organization:   OrganizationAppResource,
      logo:           FileAppResource,
      favicon:        FileAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      organization: 'organization_uuid',
      logo: 'logo_uuid',
      favicon: 'favicon_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      organizationUuid: {
        type: 'string',
        presence: true,
      },
      displayName: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      platformName: {
        type: 'string',
        ...(this.attributes.hasOwnProperty('platformName') && {
          presence: {
            allowEmpty: false,
            message: 'is required',
          },
        }),
        length: {
          maximum: 255,
        },
      },
      brandingPath: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      logoUuid: {
        type: 'string',
      },
      faviconUuid: {
        type: 'string',
      },
      primaryColor: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      primaryColorLighten: {
        type: 'string',
        length: {
          maximum: 10,
        },
      },
      primaryColorDarken: {
        type: 'string',
        length: {
          maximum: 10,
        },
      },
      accentColor: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      compiled: {
        type: 'array',
      },
      affiliateNewMembers: {
        type: 'boolean',
      },
    };
  }

}

export default OrganizationBrandingAppResource;
